<div class="modal modal__opened" [class.modal_size_488]="!deleteInProgress" [class.modal_size_744]="deleteInProgress">
  <ng-container *ngIf="!deleteInProgress else trackRemoved">
    <div class="modal__container">
      <div class="modal__title modal__title-mb12 h2">{{ 'delete-melody-modal.title' | translate: {melodyTitle: melody.title} }}</div>
      <div class="modal__text">{{ 'delete-melody-modal.text' | translate }}</div>
    </div>
    <div class="modal__buttons-row modal__buttons-mt40">
      <div class="button" (click)="deleteMelody()">{{ 'delete-melody-modal.delete' | translate }}</div>
      <div class="button button_type_light" (click)="close()">{{ 'delete-melody-modal.cancel' | translate }}</div>
    </div>
  </ng-container>
</div>

<ng-template #trackRemoved>
  <div class="modal__close icon icon-close" (click)="close()"></div>
  <div class="modal__container">
    <div class="modal__img">
      <div class="modal-img modal-img_name_congratulations modal-img_size_192"></div>
    </div>
    <div class="modal__title modal__title-mb12 h2">{{ 'delete-melody-modal.delete-in-progress-title' | translate }}</div>
    <div class="modal__text">{{ 'delete-melody-modal.delete-in-progress-text' | translate }}</div>
  </div>
  <div class="modal__buttons-row modal__buttons-mt40">
    <div class="button" (click)="close()">{{ 'delete-melody-modal.delete-in-progress-ok-btn' | translate }}</div>
  </div>
</ng-template>
